module.exports = __webpack_public_path__ + "img/Frueher-1920.2fb266cf.jpg";